import styled from 'styled-components';

export const Container = styled.div`
max-width: 950px;
width: 100%;
margin: auto;
overflow: hidden;
`;
